import { render, staticRenderFns } from "./BaseParabolaAnimate.vue?vue&type=template&id=7aff64a0&scoped=true&"
import script from "./BaseParabolaAnimate.vue?vue&type=script&lang=js&"
export * from "./BaseParabolaAnimate.vue?vue&type=script&lang=js&"
import style0 from "./BaseParabolaAnimate.vue?vue&type=style&index=0&id=7aff64a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff64a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7aff64a0', component.options)
    } else {
      api.reload('7aff64a0', component.options)
    }
    module.hot.accept("./BaseParabolaAnimate.vue?vue&type=template&id=7aff64a0&scoped=true&", function () {
      api.rerender('7aff64a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseParabolaAnimate.vue"
export default component.exports